import { useState } from "react";
import "../../css/Help.css";

/**
 * The Help component represents the help page.
 * It includes the common questions and answers and gives instructions
 * to the users.
 *
 * @returns {JSX.Element} The Help page JSX.
 */
const Help = () => {
  const helpData = [
    {
      question: "how do I upload a 3D model?",
      answer:
        "to upload a 3D model, go to the menu page and add a menu item. before saving the item, click on the 'upload 3D model' box and select the wanted .glb file. once the menu item is saved, the 3D model will be uploaded.",
    },
    {
      question: "how do I get a financial report?",
      answer:
        "to get a financial report, go to the reports page and download the template .xlsx file. fill in the data and upload the file back to the reports page. the financial report will be generated and can be downloaded using the download button in the table of reports.",
    },
  ];
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleItem = (index) => {
    setOpenIndexes((prevIndexes) =>
      prevIndexes.includes(index)
        ? prevIndexes.filter((i) => i !== index)
        : [...prevIndexes, index]
    );
  };

  return (
    <div className="Help-container">
      <div className="Help">
        <div className="Help-header">
          <h1 className="Help-title">help</h1>
        </div>
        <div className="Help-questions-container">
          {helpData.map((item, index) => (
            <div key={index} className="Help-item">
              <button
                className={`Help-question ${
                  openIndexes.includes(index) ? "active" : ""
                }`}
                onClick={() => toggleItem(index)}
              >
                {item.question}
              </button>
              <div
                className={`Help-answer ${
                  openIndexes.includes(index) ? "show" : ""
                }`}
              >
                {item.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Help;
